import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Scan"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.75 21.75H3.75C2.92157 21.75 2.25 21.0784 2.25 20.25V3.75C2.25 2.92157 2.92157 2.25 3.75 2.25H15.75V3.75H3.75V20.25H15.75V21.75ZM11.25 6.75H12.75V17.25H11.25V6.75ZM20.25 6.75H21.75V17.25H20.25V6.75ZM17.25 6.75H15.75V17.25H17.25V6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Scan.vue"]]);
